<template>
  <div>
    <div id="show-overlay"></div>
    <div>
      <!-- Sidebar  -->
      <div id="content-page" :class="horizontal ? 'ml-0' : ''" class="content-page">
        <!-- TOP Nav Bar -->
        <NavBar :horizontal="horizontal" :horizontalMenuSetting="horizontalMenuSetting" :items="horizontalMenu"
          :logo="logo" :organization="selectedOrganization" :wallet="wallet" class="theme-color-navbar" title="CITA.IO"
          @toggle="sidebarMini">
          <template slot="logo">
            <ul class="navbar-nav navbar-list menu-icons-position">
              <li class="ml-4 nav-item">
                <a class="search-toggle iq-waves-effect top-logo" href="#">
                  <router-link :to="homeURL"><b-avatar class="mr-2 cursor-point" size="2em" square
                      v-bind:src="selectedOrganization.logoUrl + '/' + getAuthentication()"></b-avatar></router-link>
                  <i class="ri-arrow-down-s-line" v-if="user.userOrganizations && user.userOrganizations.length > 1"></i>
                </a>
                <div class="iq-sub-dropdown dropmenu-500-scroll" v-if="user.userOrganizations && user.userOrganizations.length > 1">
                  <div class="iq-card-body p-0">
                    <div class="bg-primary p-3">
                      <h5 class="mb-0 text-white">
                        {{ $t("public.layouts.HomeLayout.organizations") }}
                      </h5>
                    </div>
                  </div>
                  <a v-for="(organization, i) in user.userOrganizations" :key="`organization${i}`" class="iq-sub-card"
                    href="javascript:void(0)" @click="changeOrganization(organization, true)">
                    <b-avatar class="mr-2 cursor-point" size="2em" square
                      v-bind:src="organization.logoUrl + '/' + getAuthentication()"></b-avatar>
                    {{ organization.name }}
                  </a>
                </div>
              </li>
            </ul>
          </template>
          <template slot="responsiveRight">
            <ul class="navbar-nav ml-auto navbar-list menu-icons-position">
              <li class="nav-item">
                <div class="clock lang-menu-complements" v-text="currentTime"></div>
              </li>
              <li class="nav-item">
                <a class="search-toggle iq-waves-effect language-title" href="#"
                  v-if="selectedTimeZone && selectedTimeZone.text">
                  {{ selectedTimeZone.text }} <i class="ri-arrow-down-s-line title-typography-color"></i>

                </a>
                <div class="iq-sub-dropdown dropmenu-500-scroll">
                  <a v-for="(timeZone, i) in timeZoneOptions" :key="`Lang${i}`" class="iq-sub-card"
                    href="javascript:void(0)" @click="timeZoneChange(timeZone)">
                    {{ timeZone.text }}
                  </a>
                </div>
              </li>
              <li class="nav-item">
                <a class="search-toggle iq-waves-effect language-title" href="#">
                  <img :src="selectedLang.image" alt="img-flaf" class="img-fluid mr-1"
                    style="height: 16px; width: 16px" />
                  <span class="lang-menu-complements title-typography-color">
                    {{ selectedLang.title }}</span>
                  <i class="ri-arrow-down-s-line title-typography-color"></i>
                </a>
                <div class="iq-sub-dropdown">
                  <a v-for="(lang, i) in langsOptions" :key="`Lang${i}`" class="iq-sub-card" href="javascript:void(0)"
                    @click="langChange(lang)">
                    <img :src="lang.image" alt="img-flaf" class="img-fluid mr-2" />
                    {{ lang.title }}
                  </a>
                </div>
              </li>
              <li class="nav-item">
                <a class="search-toggle iq-waves-effect title-typography-color" href="javascript:void(0)"
                  @click="openMenuHelp()">
                  {{ $t("public.layouts.HomeLayout.help") }}
                </a>
              </li>
              <li class="nav-item">
                <a class="search-toggle iq-waves-effect ml-4" href="#">
                  <i class="ri-mail-open-fill title-typography-color"></i>
                  <span v-if="alerts &&
                    alerts.content &&
                    alerts.pageable &&
                    alerts.pageable.total !== 0
                    " class="bg-danger dots"></span>
                </a>
                <div v-if="alerts && alerts.content && alerts.pageable" class="iq-sub-dropdown">
                  <div class="iq-card shadow-none m-0">
                    <div class="iq-card-body p-0">
                      <div class="bg-primary p-3 background-typography">
                        <h5 class="mb-0 text-white">
                          {{ $t("public.layouts.HomeLayout.allMessages") }}
                          <small class="badge badge-light float-right pt-1">{{
                            alerts.pageable.total
                          }}</small>
                        </h5>
                      </div>
                      <div v-for="(item, index) in alerts.content" :key="index">
                        <a v-if="index <= 4" class="iq-sub-card cursor-point" @click="showAlert">
                          <div class="media align-items-center">
                            <div class>
                              <b-avatar :v-bind:src="item.userSender.avatarUrl
                                ? item.userSender.avatarUrl +
                                '/' +
                                getAuthentication()
                                : ''
                                " class="avatar-40 rounded"></b-avatar>
                            </div>
                            <div class="media-body ml-3">
                              <h6 class="mb-0">
                                {{ item.userSender.name }}
                                {{ item.userSender.lastname }}
                              </h6>
                              <small class="float-left font-size-12">
                                {{
                                  item.scheduled | adjustToTimezone("DD/MM/YYYY HH:mm")
                                }}
                              </small>
                            </div>
                          </div>
                        </a>
                      </div>
                      <a @click="showAlert">
                        <div class="media align-items-center cursor-point">
                          <div class="media-body px-md-3 text-right">
                            {{ $t("public.layouts.HomeLayout.seeAll") }}
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </template>
          <template slot="right">
            <ul class="navbar-list mobile-hide">
              <li>
                <a class="
                                                                                                                                                                                                                                                        search-toggle
                                                                                                                                                                                                                                                        iq-waves-effect
                                                                                                                                                                                                                                                        d-flex
                                                                                                                                                                                                                                                        align-items-center
                                                                                                                                                                                                                                                      "
                  href="#">
                  <div>
                    <b-avatar class="mr-2" size="2.5em" v-bind:src="user.avatarUrl
                      ? user.avatarUrl +
                      '/' +
                      getAuthentication()
                      : ''
                      "></b-avatar>
                  </div>

                  <div v-if="user && user.name" class="caption">
                    <h6 v-if="user.name.length < 14" class="mb-0 line-height title-typography-color">
                      {{ user.name }}
                    </h6>
                    <h6 v-else class="mb-0 line-height title-typography-color">
                      {{ user.name.substring(0, 13) + "..." }}
                    </h6>
                    <span v-if="user.role === 'PATIENT' &&
                      user.userOrganizations[0].useWallet &&
                      wallet.total !== undefined
                      " class="font-size-16">
                      {{ $t("public.layouts.HomeLayout.wallet.text") }}:
                      {{ wallet.total.toFixed(2) }} €
                    </span>
                    <span v-else class="font-size-16">
                      <i class="fas fa-chevron-down"></i>
                    </span>
                  </div>
                </a>
                <div class="iq-sub-dropdown iq-dropdown">
                  <div class="iq-card shadow-none m-0">
                    <div class="iq-card-body p-0">
                      <div class="theme-color-navbar p-3 background-typography">
                        <h5
                          class="
                                                                                                                                                                                                                                                                mb-0
                                                                                                                                                                                                                                                                line-height
                                                                                                                                                                                                                                                                text-white
                                                                                                                                                                                                                                                              ">
                          {{ $t("public.layouts.HomeLayout.hi") }}
                          {{ user.name }}
                        </h5>
                        <a v-if="user.role === 'PATIENT' &&
                          user.userOrganizations[0].useWallet &&
                          wallet.total !== undefined
                          " class="text-white font-size-16" href="javascript:void(0)" @click="showWallet">
                          {{ $t("public.layouts.HomeLayout.balance") }}:
                          {{ wallet.total.toFixed(2) }} €
                        </a>
                        <span class="font-size-16 mr-2">
                          <b-badge v-if="user.role === 'SUPERADMIN'" variant="danger">{{
                            $t("public.layouts.HomeLayout.superAdmin")
                          }}</b-badge>
                        </span>
                        <span class="font-size-16 mr-2">
                          <b-badge v-if="user.role === 'ADMIN'" variant="danger">{{
                            $t("public.layouts.HomeLayout.admin")
                          }}</b-badge>
                        </span>
                        <span v-if="user.organizationRoles &&
                            user.organizationRoles.length != 0
                            " class="font-size-16">
                          <b-badge v-for="(item, index) in user.organizationRoles" :key="index" variant="success">{{
                            item
                          }}</b-badge>
                        </span>
                      </div>
                      <router-link v-for="(item, index) in horizontalMenuSetting" :key="index" v-b-toggle="item.title"
                        :to="item.link" class="iq-sub-card iq-bg-primary-hover">
                        <div class="media align-items-center">
                          <div
                            class="
                                                                                                                                                                                                                                                                  rounded
                                                                                                                                                                                                                                                                  iq-card-icon
                                                                                                                                                                                                                                                                  background-typography
                                                                                                                                                                                                                                                                  text-white
                                                                                                                                                                                                                                                                ">
                            <i :class="item.icon"></i>
                          </div>
                          <div class="media-body ml-3">
                            <h6 class="mb-0">
                              {{ $t(item.i18n) }}
                            </h6>
                            <p class="mb-0 font-size-16">
                              {{ $t(item.i18nSubtitle) }}
                            </p>
                          </div>
                        </div>
                      </router-link>
                      <div class="d-inline-block w-100 text-center p-3">
                        <a class="iq-bg-danger iq-sign-btn" href="javascript:void(0)" role="button" @click="logout">
                          {{ $t("public.layouts.HomeLayout.exit") }}
                          <i class="ri-login-box-line ml-2"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </template>
        </NavBar>
        <!-- TOP Nav Bar END -->
        <transition :enter-active-class="`animated ${animated.enter}`" :leave-active-class="`animated ${animated.exit}`"
          mode="out-in" name="router-anim">
          <router-view />
        </transition>
        <FooterStyle>
          <template v-slot:left>
            <ul>
              <li v-for="(item, index) in footer.footerLanguages" :key="index" class="list-inline-item">
                <a class="cursor-point" @click="openItem(index)">{{ item.title.content }} </a><span
                  v-if="index < footer.footerLanguages.length"> | </span>
                <b-modal :id="'modal-' + index" :title="item.title.content" centered hide-header-close ok-only size="xl">
                  <p v-html="item.content.content"></p>
                </b-modal>
              </li>
              <a class="cursor-point" @click="showAlertHelp">{{
                $t("public.layouts.HomeLayout.help")
              }}</a>
            </ul>
          </template>
          <template v-slot:right v-if="copyright">
            {{ copyright }}
          </template>
          <template v-slot:right v-else>
            Copyright 2021
            <a href="#">CITA.IO</a>
          </template>
        </FooterStyle>
      </div>
    </div>
    <b-modal id="modal-alert-totalPending" centered hide-footer size="lg" @hide="closeModalTodalPending">
      <template #modal-title>
        {{ $t("public.layouts.HomeLayout.modal.title") }}
      </template>
      <form action="#">
        <b-alert show variant="danger">{{ $t("public.layouts.HomeLayout.modal.body") }}
          {{ user.organizationTotalPending }}
        </b-alert>
      </form>
    </b-modal>
    <b-modal id="modal-alert-welcomeMessage" centered hide-footer size="lg">
      <template #modal-title>
        {{ $t("public.layouts.HomeLayout.modal.welcomeMessage.title") }}
      </template>
      <form action="#">
        {{ selectedOrganization.welcomeMessage }}
      </form>
    </b-modal>
    <b-modal id="modal-alert-status" centered hide-footer size="lg">
      <template #modal-title>
        {{ $t("public.layouts.HomeLayout.modal.alert.status.title") }}
      </template>
      <form action="#">
        {{ $t("public.layouts.HomeLayout.modal.alert.status.body") }}
        <a class="cursor-point" @click="sendInvitationProfessional">{{
          $t("public.layouts.HomeLayout.modal.alert.status.link")
        }}</a>
      </form>
    </b-modal>
    <b-modal id="modal-alert-help" centered hide-footer size="lg">
      <template #modal-title>
        {{ $t("public.layouts.HomeLayout.help") }}
      </template>
      <p v-html="help.value"></p>
    </b-modal>
    <cookie-law>
      <div slot-scope="props">
        {{ $t("cookie.law.text") }}

        <div class="row">
          <div class="col-sm-12">
            <div class="text-center">
              <b-button class="pull-center mr-2" variant="success" @click="props.accept">
                {{ $t("cookie.law.btnAccept") }}
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </cookie-law>
  </div>
</template>
<script>
//JSON Mock
import MenuHelp from "../json/MenuHelp";

import routes from "../router/index";

import NavBar from "../components/xray/navbars/NavBar";

import { xray } from "../config/pluginInit";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";

//Services
import menuService from "../services/menu";
import walletService from "../services/wallet";
import CookieLaw from "vue-cookie-law";

import userService from "../services/user";
import alertService from "../services/alert";
import organizationService from "../services/organization";
import professionalService from "../services/professional";
import footerService from "../services/footer";
import utilsService from "../services/utils";
import helpService from "../services/help";

export default {
  name: "HomeLayout",
  components: {
    CookieLaw,
    NavBar,
  },
  mounted() {
    //Clock
    this.currentTime = moment().format("LTS");
    this.clockInterval = setInterval(() => this.updateCurrentTime(), 1 * 1000);
    //--
    //this.getAllNotification();
    this.getAllAlert();
    this.getUser();
    this.updateRadio();
    this.getAllFooter();
  },
  computed: {
    ...mapGetters({
      selectedLang: "Setting/langState",
      selectedTimeZone: "Setting/timeZoneState",
      selectedOrganization: "Setting/organizationState",
      selectedUser: "Setting/userState",
      langsOptions: "Setting/langOptionState",
      timeZoneOptions: "Setting/timeZoneOptionState",
      colors: "Setting/colorState",
    }),
  },
  watch: {},
  data() {
    return {
      clockInterval: undefined,
      currentPath: this.$route.path,

      copyright: undefined,

      file: "",
      defaultAvatar: true,

      notifications: [],
      footer: [],
      user: {},
      horizontal: false,
      mini: false,
      darkMode: false,
      animated: { enter: "zoomIn", exit: "zoomOut" },
      horizontalMenu: [],
      horizontalMenuSetting: [],
      verticalMenu: [],
      logo: "",
      rtl: false,
      alerts: [],
      //Clock
      currentTime: "",
      //Wallet
      wallet: {},
      //Organization
      help: {},
      organizationId: localStorage.getItem("organizationId"),
      //Menu help
      menuHelp: MenuHelp,

      homeURL: {
        type: Object,
        default: () => ({ name: "auth.patient.dashboard" }),
      }
    };
  },
  methods: {
    getAuthentication() {
      return localStorage.getItem('authorization');
    },
    changeDefaultColor() {
      //Update menu color
      document.documentElement.style.setProperty("--navbar", "#ffffff");
      //Update typography color
      document.documentElement.style.setProperty("--typography", "#089bab");
      //Update navbar color
      document.documentElement.style.setProperty("--wallpaper", "#eff7f8");
    },
    defaultSpLanguage() {
      var langOption = this.langsOptions.filter((lang) => lang.value === "sp");

      if (langOption && langOption[0]) {
        this.langChange(langOption[0]);
      }
    },
    goToLogin() {

      this.changeDefaultColor();
      this.defaultSpLanguage();

      utilsService.auditActivity({ action: "CREATE", module: "AUTH_LOGOUT", info: "" });

      localStorage.removeItem("organizationRoles");
      localStorage.removeItem("authorization");
      localStorage.removeItem("organizationId");
      localStorage.removeItem("type");
      localStorage.removeItem("userId");

      this.$router.push({ name: "public.signin" });
    },
    openItem(id) {
      this.$bvModal.show("modal-" + id);
    },
    changeUser(user) {
      this.userChangeState(user);
    },
    changeOrganization(organization, save = false) {
      this.organizationChangeState(organization);
      localStorage.setItem("organizationId", organization.id);

      if (this.user.role !== "PATIENT") {
        if (save) {
          this.$awn.asyncBlock(
            professionalService.changeOrganization(organization.id),
            (response) => {
              if (response) {

                this.$router.go();

              }
            },
            (error) => {
              this.logout();
            }
          );
        }
      }
    },
    // Help menu
    openMenuHelp() {
      let self = this;

      let data = {
        urlRef: this.$route.path
      }

      this.$awn.asyncBlock(
        helpService.getByUrlRef(data),
        (response) => {
          if (response) {
            if (response.data.id) {
              self.$router.push({
                name: "auth.help",
                query: { id: response.data.id },
              });
            } else {
              self.$swal(
                "Error",
                "No hay ayuda para la sección",
                "error"
              );
            }
          }
        },
        (error) => {
          this.logout();
        }
      );

    },
    // Footer
    getAllFooter() {
      let self = this;

      this.$awn.asyncBlock(
        footerService.getAll(),
        (response) => {
          if (response) {
            self.footer = response.data;
          }
        },
        (error) => {
          this.logout();
        },
        " "
      );
    },
    sendInvitationProfessional() {
      let self = this;

      this.$awn.asyncBlock(
        organizationService.sendInvitationProfessional(this.user.id),
        (response) => {
          if (response) {
            this.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.layouts.HomeLayout.notification.title"
              ),
              text: this.$i18n.t(
                "public.layouts.HomeLayout.notification.descSend"
              ),
              type: "success",
            });
          }
        },
        (error) => {
          this.logout();
        }
      );
    },
    closeModalTodalPending() {
      routes.push({ name: "auth.professional.organization.preferences" });
    },
    showAlertHelp() {
      this.$router.push({
        name: "auth.helps"
      });
    },
    showAlertModal() {
      if (
        this.user.organizationTotalPending &&
        this.user.organizationTotalPending != 0
      ) {
        this.$bvModal.show("modal-alert-totalPending");
      }

      if (
        this.user.role === "PATIENT" &&
        this.selectedOrganization.welcomeMessage
      ) {
        this.$bvModal.show("modal-alert-welcomeMessage");
      }

      if (this.user.status === "PENDING") {
        this.$bvModal.show("modal-alert-status");
      }
    },
    showAlert() {
      routes.push({ name: "auth.alert" });
    },
    showNotification() {
      routes.push({ name: "auth.notification" });
    },
    getWallet() {
      let self = this;

      walletService
        .get(this.user.walletId)
        .then((response) => {
          if (response) {
            self.wallet = response.data;
          }
        })
        .catch(function (error) {
          this.logout();
        });
    },
    getAllAlert() {
      let self = this;

      alertService
        .getAllPending(0, 10)
        .then((response) => {
          if (response) {
            self.alerts = response.data;
          }
        })
        .catch(function (error) {
          this.logout();
        });
    },
    updateRadio() {
      this.horizontal = this.$store.getters["Setting/horizontalMenuState"];
      this.mini = this.$store.getters["Setting/miniSidebarState"];
    },
    sidebarMini() {
      xray.triggerSet();
      this.$store.dispatch("Setting/miniSidebarAction");
      this.updateRadio();
    },
    changeCopyright(organization) {
      if (organization.copyright) {
        this.copyright = organization.copyright;
      }
    },
    changeColorPatient(organization) {
      //Update menu color
      document.documentElement.style.setProperty(
        "--navbar",
        organization.colorMenu
      );
      //Update typography color
      document.documentElement.style.setProperty(
        "--typography",
        organization.colorTypography
      );
      //Update navbar color
      document.documentElement.style.setProperty(
        "--wallpaper",
        organization.colorWallpaper
      );
    },
    changeColor(user) {
      //Update menu color
      document.documentElement.style.setProperty(
        "--navbar",
        user.organizationColorMenu
      );
      //Update typography color
      document.documentElement.style.setProperty(
        "--typography",
        user.organizationColorTypography
      );
      //Update navbar color
      document.documentElement.style.setProperty(
        "--wallpaper",
        user.organizationColorWallpaper
      );
    },
    showWallet() {
      this.$router.push({ name: "auth.patient.wallet" });
    },
    logout() {
      this.goToLogin();
    },
    langChange(lang) {
      let self = this;
      localStorage.setItem("lang", lang.value);
      this.langChangeState(lang);
      this.$i18n.locale = lang.value;

      let data = {
        timeZone: this.user.timeZone,
        language: lang.value
      };

      userService
        .updateSettings(localStorage.getItem("userId"), data)
        .then((response) => {

        })
        .catch(function (error) {
          this.logout();
        });
    },
    timeZoneChange(timeZone) {
      let self = this;
      localStorage.setItem("timeZone", timeZone.value);
      this.timeZoneChangeState(timeZone);

      let data = {
        timeZone: timeZone.value,
        language: this.user.language
      };

      userService
        .updateSettings(localStorage.getItem("userId"), data)
        .then((response) => {

        })
        .catch(function (error) {
          this.logout();
        });
    },
    ...mapActions({
      userChangeState: "Setting/setUserAction",
      organizationChangeState: "Setting/setOrganizationAction",
      timeZoneChangeState: "Setting/setTimeZoneAction",
      langChangeState: "Setting/setLangAction",
      rtlAdd: "Setting/setRtlAction",
      rtlRemove: "Setting/removeRtlAction",
    }),
    getMenuSetting(role, type) {
      let self = this;
      menuService
        .getSetting(role, type)
        .then((response) => {
          if (response && response.data) {
            this.horizontalMenuSetting = response.data;
          } else {
            routes.push({ name: "public.signin" });
          }
        })
        .catch(function (error) {
          this.logout();
        });
    },
    getMenu(role, type) {
      let self = this;
      menuService
        .get(role, type)
        .then((response) => {
          if (response && response.data) {
            this.horizontalMenu = response.data;
          } else {
            routes.push({ name: "public.signin" });
          }
        })
        .catch(function (error) {
          this.logout();
        });
    },
    getUser() {
      let self = this;
      userService
        .get(localStorage.getItem("userId"))
        .then((response) => {
          if (response) {
            self.user = response.data;
            this.getMenu(response.data.role, localStorage.getItem("type"));
            this.getMenuSetting(
              response.data.role,
              localStorage.getItem("type")
            );
            this.changeColor(response.data);
            this.logo = response.data.organizationLogo;

            // Wallet
            if (self.user.role === "PATIENT" && self.user.walletId !== null) {
              this.getWallet();
            }

            //Lang
            if (self.user.language) {
              var langOption = self.langsOptions.filter(
                (lang) => lang.value === self.user.language
              );

              if (langOption && langOption[0]) {
                self.langChange(langOption[0]);
              }
            }

            //Timezone
            if (self.user.timeZone) {
              var timeZoneOption = self.timeZoneOptions.filter(
                (timeZone) => timeZone.value === self.user.timeZone
              );

              if (timeZoneOption && timeZoneOption[0]) {
                self.timeZoneChange(timeZoneOption[0]);
              }
            }

            // Ejemplo de uso
            var localTimezoneOption = utilsService.getLocalTimezoneOption();
            if (localTimezoneOption && localTimezoneOption !== self.user.timeZone) {

              this.$swal({
                text: "Estas intentando acceder de un lugar donde tiene un huso horario: " + localTimezoneOption + ", la configuración de tu usuario es: " + self.user.timeZone + " ¿Desea cambiarla?",
                showCancelButton: true,
                confirmButtonText: this.$i18n.t(
                  "public.views.Pages.Professional.Admin.Payments.tab.plataform.confirm.nopay.btnConfirm"
                ),
                cancelButtonText: this.$i18n.t(
                  "public.views.Pages.Professional.Admin.Payments.tab.plataform.confirm.nopay.btnCancel"
                ),
              }).then((result) => {
                if (result.isConfirmed) {
                  var timeZoneOption = self.timeZoneOptions.filter(
                    (timeZone) => timeZone.value === localTimezoneOption
                  );
                  self.timeZoneChange(timeZoneOption[0]);
                }
              });

            }

            //Patient select organization

            if (self.user.userOrganizations && self.user.userOrganizations.length !== 0) {
              const organization = self.user.userOrganizations.find(
                (org) => org.id == self.organizationId
              );

              if (organization) {
                self.changeOrganization(organization, false);
                self.changeColorPatient(organization);
                self.changeCopyright(organization);
              }
            }
            self.changeUser(self.user);
            //Alert
            self.showAlertModal();

            self.getLogo(response.data.organizationLogo);

            if (response.data.role !== "PATIENT") {
              self.homeURL.name = "auth.professional.dashboard";
            } else {
              self.homeURL.name = "auth.patient.dashboard";
            }
          }
        })
        .catch(function (error) {
          this.logout();
        });
    },
    getLogo(uuid) {
      let self = this;
      utilsService
        .getFile(uuid)
        .then((response) => {
          if (response) {
            self.defaultAvatar = false;
            self.file = response.data.data;
          } else {
            self.defaultAvatar = true;
            self.file = require("../assets/images/logo.png");
          }
        })
        .catch(function (error) {
          self.defaultAvatar = true;
          self.file = require("../assets/images/logo.png");
        });
    },
    //Clock
    updateCurrentTime() {
      this.currentTime = utilsService.adjustDateTimeClock(moment(), "LTS");
    },
  },
  beforeDestroy() {
    clearInterval(this.clockInterval);
  },
};
</script>
<style>
@import url("../assets/css/custom.css");
</style>
